import { message, PageHeader, Spin, Upload, Row, Col, Steps, Result, Select, Modal, Alert, Tooltip, Radio, Table, Tag } from "antd";
import { FileExcelOutlined, FileZipOutlined, CheckCircleOutlined, DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    Form,
    FormItem,
    ButtonItem,
    ErrorItem,
    SelectItem,
    SwitchItem,
    cuentaMask,
    dineroDisabledMask,
} from "../../../Components/Items";
import SelectEmpresasBiwoItem from "../../../Components/SelectEmpresasBiwoItem";
import SelectInsumosItem from "../../../Components/SelectInsumosItem";
import SeleccionarZipDescargaSat from "../../../Components/SeleccionarZipDescargaSat";

const { Step } = Steps;
const { Option } = Select;

class CXCImplementacion extends Component {
    formRef1 = React.createRef();
    formRef2 = React.createRef();
    state = {
        loading: false,
        paso: 0,
        archivosZip: [],
        archivosExcel: [],
        origenZip: "subir",
        zipExistenteRef: null,
        empresaId: null,
        sessionId: null,
        // datos para paso 2
        objetoUsuarios: null,
        objetoProyectos: null,
        objetoPrecios: null,
        objetoCuentasContables: null,
        objetoTipoDeCliente: null,
        verificado: false,
        verificacionMensaje: null,
        verificacionRegistros: [],
        verificacionResumen: null,
        problemasGenerales: [],
        advertencias: [],
        resultadoImplementacion: null,
    };

    // Estado de verificacion en limpio: se usa al reiniciar y cada vez que cambia una
    // opcion del paso 2, porque la verificacion anterior deja de ser valida.
    static get verificacionVacia() {
        return {
            verificado: false,
            verificacionMensaje: null,
            verificacionRegistros: [],
            verificacionResumen: null,
            problemasGenerales: [],
            advertencias: [],
        };
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    // ── Paso 1: seleccionar empresa ──────────────────────────────────────────────
    onChangeEmpresa(empresaId) {
        if (!empresaId) return;
        this.setState({ loading: true });
        axios
            .post(
                "cxcImplementacion/verificarArchivos",
                { empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2 && res.data.tieneArchivos) {
                    Modal.confirm({
                        title: "Ya hay archivos subidos para esta empresa",
                        content: "¿Deseas usar los archivos existentes o subir nuevos?",
                        okText: "Usar existentes",
                        cancelText: "Subir nuevos",
                        onOk: () => {
                            this.setState({
                                empresaId,
                                sessionId: res.data.sessionId,
                            });
                            this.consultarDatosPaso2(empresaId);
                        },
                        onCancel: () => {
                            this.setState({ empresaId, archivosZip: [], archivosExcel: [] });
                        },
                    });
                } else {
                    this.setState({ empresaId });
                }
            });
    }

    onFinishPaso1(values) {
        if (this.state.origenZip === "subir" && this.state.archivosZip.length === 0) {
            message.error("Por favor sube el archivo ZIP");
            return;
        }
        if (this.state.origenZip === "existente" && !this.state.zipExistenteRef) {
            message.error("Por favor elige un ZIP ya descargado");
            return;
        }
        if (this.state.archivosExcel.length === 0) {
            message.error("Por favor sube el archivo Excel");
            return;
        }

        this.setState({ loading: true });

        const formData = new FormData();
        formData.append("empresaId", values.empresaId);
        if (this.state.origenZip === "subir") {
            formData.append("zip", this.state.archivosZip[0].originFileObj);
        } else {
            formData.append("zipExistenteRef", this.state.zipExistenteRef);
        }
        formData.append("excel", this.state.archivosExcel[0].originFileObj);

        axios
            .post("cxcImplementacion/subirArchivos", formData, {
                headers: { ...this.props.headersToken, "Content-Type": "multipart/form-data" },
            })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Archivos subidos correctamente");
                    this.setState({ sessionId: res.data.sessionId });
                    this.consultarDatosPaso2(values.empresaId);
                } else if (res.data.success === 1) {
                    message.error("No se pudieron subir los archivos");
                } else {
                    message.error("Hubo un error al subir los archivos");
                }
            });
    }

    async consultarDatosPaso2(empresaId) {
        this.setState({ loading: true });
        await axios
            .post(
                "ventas/selectDatosParaVenta",
                { empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status !== 404) {
                    this.setState({
                        objetoUsuarios: res.data.usuariosEmpresa.map((v) => (
                            <Option value={v._id} key={v._id}>
                                {v.nombre + " " + v.apellidoPaterno + " " + (v.apellidoMaterno || "")}
                            </Option>
                        )),
                        objetoProyectos: res.data.proyectos.map((v) => (
                            <Option value={v._id} key={v._id}>{v.nombre}</Option>
                        )),
                        objetoPrecios: res.data.precios.map((v) => (
                            <Option value={v._id} key={v._id}>{v.nombre}</Option>
                        )),
                    });
                }
            });
        await axios
            .post(
                "cuentascontables/selectCuentasContablesFinales",
                { empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status !== 404) {
                    this.setState({
                        objetoCuentasContables: res.data.map((v) => (
                            <Option value={v._id} key={v._id}>
                                {cuentaMask(v.nivel1 + v.nivel2 + v.nivel3 + v.nivel4 + v.nivel5) + " - " + v.descripcion}
                            </Option>
                        )),
                    });
                }
            });
        await axios
            .post(
                "clientes/selectDatosParaCliente",
                { empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status !== 404) {
                    this.setState({
                        objetoTipoDeCliente: res.data.tipoDeClientes.map((v) => (
                            <Option value={v._id} key={v._id}>
                                {v.nombre + " - " + v.descripcion}
                            </Option>
                        )),
                    });
                }
            });
        this.setState({ loading: false, paso: 1 });
    }

    // ── Paso 2: verificar opciones ───────────────────────────────────────────────
    verificarOpciones() {
        const values = this.formRef2.current?.getFieldsValue();
        const campos = ["vendedorId", "proyectoId", "precioId", "insumo1Id", "insumo2Id"];
        // En modo historico no se genera poliza, asi que la cuenta de ingreso no se usa
        if (!values?.soloHistorico) campos.push("cuentaContableIngresoId");
        const faltante = campos.find((c) => !values[c]);
        if (faltante) {
            message.error("Por favor completa todos los campos antes de verificar");
            return;
        }

        this.setState({ loading: true, ...CXCImplementacion.verificacionVacia });
        axios
            .post(
                "cxcImplementacion/verificarOpciones",
                { ...values, empresaId: this.state.empresaId, sessionId: this.state.sessionId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    const resumen = res.data.resumen || { total: 0, correctos: 0, conError: 0 };
                    const problemasGenerales = res.data.problemasGenerales || [];
                    this.setState({
                        // Se puede implementar mientras haya al menos un registro bueno. Los
                        // problemas generales son los que no se pudieron atribuir a un UUID:
                        // sin saber a quien afectan no es seguro subir nada.
                        verificado: resumen.correctos > 0 && problemasGenerales.length === 0,
                        verificacionMensaje: res.data.mensaje || "Verificación terminada.",
                        verificacionRegistros: res.data.registros || [],
                        verificacionResumen: resumen,
                        problemasGenerales,
                        advertencias: res.data.advertencias || [],
                    });
                } else {
                    this.setState({ verificacionMensaje: res.data.mensaje || "La verificación encontró problemas." });
                    message.error(res.data.mensaje || "La verificación falló");
                }
            });
    }

    // ── Paso 2: implementar ──────────────────────────────────────────────────────
    onFinishPaso2(values) {
        const { verificacionRegistros, verificacionResumen } = this.state;
        const conError = verificacionResumen?.conError || 0;
        if (conError > 0) {
            Modal.confirm({
                title: `Se descartarán ${conError} registro(s)`,
                content: `Solo se van a implementar los ${verificacionResumen.correctos} registros correctos. Los ${conError} con error no se suben y podrás descargarlos para corregirlos.`,
                okText: "Implementar los correctos",
                cancelText: "Cancelar",
                onOk: () => this.implementar(values, verificacionRegistros),
            });
            return;
        }
        this.implementar(values, verificacionRegistros);
    }

    implementar(values, registros) {
        // Se manda siempre la lista, aunque esten todos correctos: el backend vuelve a
        // parsear los archivos desde cero y asi no puede colarse un registro que no paso
        // la verificacion.
        const uuidsAImplementar = registros.filter((r) => r.ok).map((r) => r.uuid);
        // Los que se descartaron en la verificacion nunca llegan al backend, asi que hay
        // que arrastrarlos para que la pantalla final liste todo lo que no se importo.
        const descartadosEnVerificacion = registros
            .filter((r) => !r.ok)
            .map((r) => ({ ...r, motivo: (r.problemas || []).join("; ") }));
        this.setState({ loading: true });
        axios
            .post(
                "cxcImplementacion/implementarCXC",
                { ...values, empresaId: this.state.empresaId, sessionId: this.state.sessionId, uuidsAImplementar },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    const importadas = res.data.importadas ?? 0;
                    const errores = [...descartadosEnVerificacion, ...(res.data.errores || [])];
                    if (errores.length > 0) {
                        message.warning(`Se importaron ${importadas} ventas y se descartaron ${errores.length}`);
                    } else {
                        message.success(`Se importaron ${importadas} ventas`);
                    }
                    this.setState({
                        paso: 2,
                        advertencias: res.data.advertencias || [],
                        resultadoImplementacion: { importadas, descartadas: errores.length, errores },
                    });
                } else if (res.data.success === 1) {
                    message.error(res.data.mensaje || "No se pudo implementar el CXC");
                    const errores = [...descartadosEnVerificacion, ...(res.data.errores || [])];
                    this.setState({
                        resultadoImplementacion: { importadas: 0, descartadas: errores.length, errores },
                    });
                } else {
                    message.error("Hubo un error al implementar el CXC");
                }
            });
    }

    // ── Paso 3: borrar archivos ──────────────────────────────────────────────────
    borrarArchivos() {
        this.setState({ loading: true });
        axios
            .post(
                "cxcImplementacion/borrarArchivos",
                { sessionId: this.state.sessionId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Archivos eliminados del servidor");
                    this.reiniciar();
                } else {
                    message.error("Hubo un error al eliminar los archivos");
                }
            });
    }

    reiniciar() {
        this.setState({
            paso: 0,
            archivosZip: [],
            archivosExcel: [],
            empresaId: null,
            sessionId: null,
            objetoUsuarios: null,
            objetoProyectos: null,
            objetoPrecios: null,
            objetoCuentasContables: null,
            objetoTipoDeCliente: null,
            resultadoImplementacion: null,
            ...CXCImplementacion.verificacionVacia,
        });
        if (this.formRef1.current) this.formRef1.current.resetFields();
        if (this.formRef2.current) this.formRef2.current.resetFields();
    }

    // Excel de los registros que no se van a subir, con su motivo, para corregir el
    // catalogo y volver a correr solo esos.
    descargarDescartados(filas) {
        if (!filas || filas.length === 0) return;
        const encabezados = ["UUID", "Referencia", "Cliente", "Fecha", "Total", "Motivo"];
        const renglones = filas.map((f) => [
            f.uuid || "",
            f.referencia || "",
            f.nombre || "",
            f.fecha ? moment(f.fecha).format("DD/MM/YYYY") : "",
            Number(f.total) || 0,
            f.motivo || (f.problemas || []).join("; "),
        ]);

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet([encabezados, ...renglones]);
        ws["!cols"] = [{ wch: 40 }, { wch: 18 }, { wch: 35 }, { wch: 12 }, { wch: 14 }, { wch: 70 }];
        XLSX.utils.book_append_sheet(wb, ws, "Descartados");
        XLSX.writeFile(wb, "descartados_cxc.xlsx");
    }

    descargarPlantilla() {
        const wb = XLSX.utils.book_new();

        const ws = XLSX.utils.aoa_to_sheet([["UUID", "Vendedor", "Referencia", "O.C.", "Dias Credito", "Fecha Vencimiento", "Codigo Cliente", "Total Pagado"]]);
        ws["!cols"] = [
            { wch: 40 }, { wch: 30 }, { wch: 20 }, { wch: 15 },
            { wch: 14 }, { wch: 20 }, { wch: 18 }, { wch: 15 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, "Plantilla CXC");

        const notas = [
            ["Columna", "Obligatorio", "Descripción"],
            ["UUID", "Sí", "Se detecta automáticamente en cualquier celda de la fila por su formato"],
            ["Vendedor", "No", "Nombre completo del vendedor"],
            ["Referencia", "No", "Texto libre, alternativa a O.C."],
            ["O.C.", "No", "Orden de compra — tiene prioridad sobre Referencia"],
            ["Dias Credito", "No", "Número entero de días de crédito"],
            ["Fecha Vencimiento", "No", "Fecha Excel o número de días (< 1000); si viene, sobreescribe Dias Credito"],
            ["Codigo Cliente", "No", "Solo importa cuando hay duplicados de RFC en la empresa"],
            ["Total Pagado", "No", "Monto total ya pagado por el cliente puede estar vacio o ser 0. Se ignora si se activa el modo 'Solo historico': ahi todas las ventas quedan cobradas al 100%"],
        ];
        const wsNotas = XLSX.utils.aoa_to_sheet(notas);
        wsNotas["!cols"] = [{ wch: 20 }, { wch: 12 }, { wch: 70 }];
        XLSX.utils.book_append_sheet(wb, wsNotas, "Instrucciones");
        XLSX.writeFile(wb, "plantilla_cxc.xlsx");
    }

    onChangeZip(file) {
        if (file.type === "application/zip" || file.type === "application/x-zip-compressed" || file.name?.endsWith(".zip")) {
            this.setState({ archivosZip: [{ ...file, status: "done", originFileObj: file }] });
        } else {
            message.error("El archivo debe ser un ZIP");
        }
    }

    onChangeExcel(file) {
        if (
            file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            file.name?.endsWith(".xlsx")
        ) {
            this.setState({ archivosExcel: [{ ...file, status: "done", originFileObj: file }] });
        } else {
            message.error("El archivo debe ser un Excel (.xlsx)");
        }
    }

    // ── Renders ──────────────────────────────────────────────────────────────────
    renderPaso0() {
        return (
            <Form
                ref={this.formRef1}
                name="cxcPaso1"
                layout
                bottom={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Tooltip title="Descarga la plantilla Excel con las columnas que acepta el sistema">
                            <ButtonItem
                                icon={<DownloadOutlined />}
                                onClick={this.descargarPlantilla.bind(this)}
                            >
                                Descargar plantilla Excel
                            </ButtonItem>
                        </Tooltip>
                        <ButtonItem type="primary" htmlType="submit">
                            Subir archivos
                        </ButtonItem>
                    </div>
                }
                onFinish={this.onFinishPaso1.bind(this)}
                onFinishFailed={this.onFinishFailed.bind(this)}
            >
                <Row style={{ marginTop: 20 }}>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="empresaId" label="Empresa" required>
                            <SelectEmpresasBiwoItem
                                placeholder="Seleccionar empresa"
                                onChange={this.onChangeEmpresa.bind(this)}
                            />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <FormItem label="Origen del ZIP">
                            <Radio.Group
                                value={this.state.origenZip}
                                onChange={(e) => this.setState({ origenZip: e.target.value, archivosZip: [], zipExistenteRef: null })}
                            >
                                <Radio.Button value="subir">Subir ZIP nuevo</Radio.Button>
                                <Radio.Button value="existente">Usar uno ya descargado</Radio.Button>
                            </Radio.Group>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        {this.state.origenZip === "subir" ? (
                            <FormItem label="Archivo ZIP">
                                <Upload
                                    showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                                    fileList={this.state.archivosZip}
                                    customRequest={({ file, onSuccess }) => { this.onChangeZip(file); onSuccess("ok"); }}
                                    accept=".zip"
                                    maxCount={1}
                                >
                                    <ButtonItem icon={<FileZipOutlined />}>Subir ZIP</ButtonItem>
                                </Upload>
                            </FormItem>
                        ) : (
                            <FormItem label="ZIP ya descargado (Emisión)">
                                <SeleccionarZipDescargaSat
                                    empresaId={this.state.empresaId}
                                    emision={true}
                                    headersToken={this.props.headersToken}
                                    value={this.state.zipExistenteRef}
                                    onChange={(value) => this.setState({ zipExistenteRef: value })}
                                />
                            </FormItem>
                        )}
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem label="Archivo Excel">
                            <Upload
                                showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                                fileList={this.state.archivosExcel}
                                customRequest={({ file, onSuccess }) => { this.onChangeExcel(file); onSuccess("ok"); }}
                                accept=".xlsx"
                                maxCount={1}
                            >
                                <ButtonItem icon={<FileExcelOutlined />}>Subir Excel</ButtonItem>
                            </Upload>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );
    }

    // Columnas de la tabla de verificacion. Se usa Table de antd y no TableItem porque
    // TableItem ignora pagination y scroll, y aqui hacen falta las dos.
    columnasVerificacion() {
        return [
            { title: "Referencia", dataIndex: "referencia", width: 120, render: (v, r) => v || r.uuid },
            { title: "Cliente", dataIndex: "nombre", width: 260, ellipsis: true },
            {
                title: "Fecha",
                dataIndex: "fecha",
                width: 110,
                render: (v) => (v ? moment(v).format("DD/MM/YYYY") : ""),
            },
            {
                title: "Total",
                dataIndex: "total",
                width: 120,
                align: "right",
                render: (v) => dineroDisabledMask(Number(v) || 0),
            },
            {
                title: "Estado",
                dataIndex: "ok",
                width: 110,
                filters: [
                    { text: "Correcto", value: true },
                    { text: "Con error", value: false },
                ],
                onFilter: (value, record) => record.ok === value,
                render: (ok) =>
                    ok ? <Tag color="green">Correcto</Tag> : <Tag color="red">Con error</Tag>,
            },
            {
                title: "Problemas",
                dataIndex: "problemas",
                render: (problemas) =>
                    problemas?.length ? (
                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                            {problemas.map((p, i) => (
                                <li key={i}>{p}</li>
                            ))}
                        </ul>
                    ) : (
                        ""
                    ),
            },
        ];
    }

    renderPaso1() {
        const {
            verificado,
            verificacionMensaje,
            verificacionRegistros,
            verificacionResumen,
            problemasGenerales,
            advertencias,
        } = this.state;
        const conError = verificacionResumen?.conError || 0;
        const correctos = verificacionResumen?.correctos || 0;
        const descartados = verificacionRegistros.filter((r) => !r.ok);
        return (
            <Form
                ref={this.formRef2}
                name="cxcPaso2"
                layout
                initialValues={{ soloHistorico: false }}
                onValuesChange={() => this.setState({ ...CXCImplementacion.verificacionVacia })}
                bottom={
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
                        {conError > 0 && (
                            <ButtonItem
                                icon={<DownloadOutlined />}
                                onClick={() => this.descargarDescartados(descartados)}
                            >
                                Descargar descartados ({conError})
                            </ButtonItem>
                        )}
                        <ButtonItem onClick={this.verificarOpciones.bind(this)}>
                            Verificar
                        </ButtonItem>
                        <ButtonItem
                            type="primary"
                            htmlType="submit"
                            disabled={!verificado}
                        >
                            {conError > 0
                                ? `Implementar solo los correctos (${correctos})`
                                : `Implementar${correctos > 0 ? ` (${correctos})` : ""}`}
                        </ButtonItem>
                    </div>
                }
                onFinish={this.onFinishPaso2.bind(this)}
                onFinishFailed={this.onFinishFailed.bind(this)}
            >
                <Row style={{ marginTop: 20 }}>
                    <Col span={24}>
                        <FormItem
                            name="soloHistorico"
                            label="Solo historico (no contabilizar)"
                            valuePropName="checked"
                            tooltip="No genera poliza ni cargos y abonos. Las ventas quedan cobradas al 100% y no aparecen en Cuentas por Cobrar. Usalo solo para cargar el historial de ventas de la empresa."
                        >
                            <SwitchItem />
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="vendedorId" label="Vendedor" required>
                            <SelectItem placeholder="Vendedor">
                                {this.state.objetoUsuarios}
                            </SelectItem>
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="proyectoId" label="Proyecto" required>
                            <SelectItem placeholder="Proyecto">
                                {this.state.objetoProyectos}
                            </SelectItem>
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="precioId" label="Precio" required>
                            <SelectItem placeholder="Precio">
                                {this.state.objetoPrecios}
                            </SelectItem>
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem shouldUpdate noStyle>
                            {({ getFieldValue }) => {
                                const historico = getFieldValue("soloHistorico");
                                return (
                                    <FormItem
                                        name="cuentaContableIngresoId"
                                        label={historico ? "Cuenta Contable de Ingreso (opcional)" : "Cuenta Contable de Ingreso"}
                                        required={!historico}
                                    >
                                        <SelectItem placeholder="Cuenta Contable de Ingreso" showSearch>
                                            {this.state.objetoCuentasContables}
                                        </SelectItem>
                                    </FormItem>
                                );
                            }}
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="insumo1Id" label="Insumo 1" required>
                            <SelectInsumosItem
                                placeholder="Insumo 1"
                                empresaId={this.state.empresaId}
                            />
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="insumo2Id" label="Insumo 2" required>
                            <SelectInsumosItem
                                placeholder="Insumo 2"
                                empresaId={this.state.empresaId}
                            />
                        </FormItem>
                    </Col>
                    <Col span={24} xs={24} sm={24} md={12} lg={12}>
                        <FormItem name="tipoClienteId" label="Tipo de cliente (para clientes sin tipo)">
                            <SelectItem placeholder="Tipo de cliente" allowClear>
                                {this.state.objetoTipoDeCliente}
                            </SelectItem>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        if (getFieldValue("soloHistorico")) {
                            return (
                                <Alert
                                    style={{ marginTop: 12 }}
                                    type="info"
                                    showIcon
                                    message="Modo solo historico activado"
                                    description={
                                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                                            <li>No se genera poliza ni cargos y abonos.</li>
                                            <li>Todas las ventas quedan cobradas al 100%, ignorando la columna "Total Pagado" del Excel.</li>
                                            <li>No apareceran en Cuentas por Cobrar ni en la antiguedad de saldos.</li>
                                        </ul>
                                    }
                                />
                            );
                        }
                    }}
                </FormItem>
                {verificacionMensaje && (
                    <Alert
                        style={{ marginTop: 12 }}
                        type={correctos === 0 ? "error" : conError > 0 ? "warning" : "success"}
                        showIcon
                        message={verificacionMensaje}
                        description={
                            conError > 0
                                ? "Los registros con error se descartan: no se suben y no bloquean a los demás. Descárgalos para corregir el catálogo y vuelve a correr el proceso solo con ellos."
                                : undefined
                        }
                    />
                )}
                {problemasGenerales.length > 0 && (
                    <Alert
                        style={{ marginTop: 12 }}
                        type="error"
                        showIcon
                        message="Problemas que no se pudieron atribuir a un CFDI en particular"
                        description={
                            <>
                                <ul style={{ margin: 0, paddingLeft: 16 }}>
                                    {problemasGenerales.map((p, i) => <li key={i}>{p}</li>)}
                                </ul>
                                <div style={{ marginTop: 8 }}>
                                    No se sabe a qué registros afectan, así que no es seguro implementar.
                                    Corrígelos y vuelve a verificar.
                                </div>
                            </>
                        }
                    />
                )}
                {verificacionRegistros.length > 0 && (
                    <Table
                        style={{ marginTop: 12 }}
                        rowKey="uuid"
                        size="small"
                        columns={this.columnasVerificacion()}
                        dataSource={verificacionRegistros}
                        pagination={{ pageSize: 10, showSizeChanger: true, showTotal: (t) => `${t} registro(s)` }}
                        scroll={{ x: true }}
                    />
                )}
                {advertencias.length > 0 && (
                    <Alert
                        style={{ marginTop: 12 }}
                        type="warning"
                        showIcon
                        message={`${advertencias.length} advertencia(s) — los demás registros se importarán correctamente`}
                        description={
                            <ul style={{ margin: 0, paddingLeft: 16 }}>
                                {advertencias.map((adv, i) => <li key={i}>{adv}</li>)}
                            </ul>
                        }
                    />
                )}
            </Form>
        );
    }

    renderPaso2() {
        const { advertencias, resultadoImplementacion } = this.state;
        const importadas = resultadoImplementacion?.importadas ?? 0;
        const descartadas = resultadoImplementacion?.descartadas ?? 0;
        const errores = resultadoImplementacion?.errores || [];
        return (
            <>
            {descartadas > 0 && (
                <Alert
                    style={{ marginBottom: 16 }}
                    type="warning"
                    showIcon
                    message={`Se descartaron ${descartadas} registro(s)`}
                    description={
                        <>
                            <ul style={{ margin: 0, paddingLeft: 16 }}>
                                {errores.map((e, i) => (
                                    <li key={i}>{[e.referencia || e.uuid, e.motivo].filter(Boolean).join(": ")}</li>
                                ))}
                            </ul>
                            <ButtonItem
                                style={{ marginTop: 8 }}
                                icon={<DownloadOutlined />}
                                onClick={() => this.descargarDescartados(errores)}
                            >
                                Descargar descartados
                            </ButtonItem>
                        </>
                    }
                />
            )}
            {advertencias.length > 0 && (
                <Alert
                    style={{ marginBottom: 16 }}
                    type="warning"
                    showIcon
                    message={`${advertencias.length} advertencia(s)`}
                    description={
                        <ul style={{ margin: 0, paddingLeft: 16 }}>
                            {advertencias.map((adv, i) => <li key={i}>{adv}</li>)}
                        </ul>
                    }
                />
            )}
            <Result
                status="success"
                title={`Se importaron ${importadas} venta(s)`}
                subTitle={
                    descartadas > 0
                        ? `${descartadas} registro(s) quedaron sin importar. Presiona el botón para eliminar los archivos temporales del servidor.`
                        : "Presiona el botón para eliminar los archivos temporales del servidor."
                }
                extra={[
                    <ButtonItem
                        key="borrar"
                        type="primary"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={this.borrarArchivos.bind(this)}
                    >
                        Borrar archivos del servidor
                    </ButtonItem>,
                ]}
            />
            </>
        );
    }

    render() {
        const { paso, loading } = this.state;
        return (
            <>
                <PageHeader
                    title="CXC Implementación"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div className="card-background" style={{ paddingTop: 5 }}>
                    <Spin spinning={loading}>
                        <Steps current={paso} size="small" style={{ padding: "16px 0 20px" }}>
                            <Step title="Archivos" description="Empresa, ZIP y Excel" />
                            <Step title="Implementar" description="Seleccionar opciones" />
                            <Step title="Finalizar" description="Borrar archivos" icon={<CheckCircleOutlined />} />
                        </Steps>

                        {paso === 0 && this.renderPaso0()}
                        {paso === 1 && this.renderPaso1()}
                        {paso === 2 && this.renderPaso2()}
                    </Spin>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(CXCImplementacion);
